import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/commons/auth.service';
import { NavigationService } from '../services/commons/navigation.service';
import { StorageService } from '../services/commons/storage.service';
import { GlobalMethodsService } from '../services/global-methods.service';
import { Platform } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private authService: AuthService,
    private navigation: NavigationService,
    private storage: StorageService,
    private platform: Platform) { }

  async canActivate() {
    if (await this.authService.ifAuthLoggedIn() && await this.isValidatedTokenWeb()) {
      return true;
    } else {
      this.navigation.logout(false);
      return false;
    }
  }

  async isValidatedTokenWeb() {
    if(await this.platform.is('cordova')){
      return true;
    }else{
      let tokenWeb = await this.storage.getObject('TOKEN_WEB');
      let currentDate = new Date();
      if (currentDate.getTime() >= tokenWeb) {
        await this.authService.deleteTokenWeb();
        await this.navigation.logout();
        return false;
      } else {
        let newTime = currentDate;
        newTime.setHours(newTime.getHours() + 4);
        tokenWeb = newTime.getTime();
        await this.storage.setObject('TOKEN_WEB', tokenWeb);
        await this.authService.startCronTokenWeb();
        return true;
      }
    }
  }

}
